// extracted by mini-css-extract-plugin
module.exports = {"textAreaRoot":"styles_textAreaRoot__2kaFV","confirmationHeader":"styles_confirmationHeader__1tq37"};